import { COMPANY, MANUFACTURES } from "./endpoints";
import APIV2 from "../utils/apiV2Utils";
import { getPathParam, serialize } from "../utils/converter";

export const getRegistryManufactures = ({ company_id, params, signal }) =>
    APIV2.get(getPathParam([COMPANY, company_id, MANUFACTURES]) + (params ? serialize(params) : ""), { signal });
